// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"765":"f77b483a","858":"ed862138"}[chunkId] + ".chunk.js";
};